import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  code: "USD",      // default currency code
  name: "US Dollar", 
  symbol: "$",      // default symbol
};

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setCurrency: (state, action) => {
      const { code, name, symbol } = action.payload;
      if (code !== undefined) state.code = code;
      if (name !== undefined) state.name = name;
      if (symbol !== undefined) state.symbol = symbol;
    },
    resetCurrency: () => initialState,
  },
});

export const { setCurrency, resetCurrency } = currencySlice.actions;

export default currencySlice.reducer;
